export const mediaQueries = {
  desktop: "(min-width: 1051px)",
  mobile: "(max-width: 1050px)",
};
